module.exports = __webpack_public_path__ + "img/Gallery_3_09.a3902cab.jpeg";